import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Product } from 'src/models/DTO/products/product';
import { Config } from '../../../infrastructure/config';
import { RequestHelper } from '../../../infrastructure/core/requestHelper';
import { Item } from '../../../models/DTO/items/item';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  private getProductUrl: string = Config.api + "product/";

  constructor(private http: HttpClient) { }

  public getProductInfo(productUUID: string) {
    let params = productUUID + "?fields%5Bskus%5D=id%2Cproduct_id%2Cuuid%2Csku%2Cavailable_quantity%2Creserved_quantity&append=total_available_quantity%2Ctotal_reserved_quantity&fields%5Bpricing%5D=id%2Cproduct_id%2Cuuid%2Cquantity_from%2Cquantity_to%2Cprice_per_piece&fields%5Bcategory%5D=id%2Cuuid%2Cname&fields%5Bproducts%5D=id%2Cuuid%2Cname%2Corganisation_id%2Cproduct_condition%2Ccreated_at%2Cupdated_at%2Ccategory_id%2Cbrand_id%2Cmanufacturer_id%2Cdescription%2Cguarantee_in_months%2Cean%2Csku%2Cvat_percentage&include=brand%2Ccategory%2Cmanufacturer%2Cskus%2Cpricing%2Corganisation%2Cpackaging%2Cskus.options%2Cskus.options.option%2Cskus.options.option.values&fields%5Bmanufacturer%5D=id%2Cuuid%2Cname";
    return this.http.get<Product>(this.getProductUrl + params);
  }
}
